"use client";

import { motion } from "framer-motion";
import { Database, CircleCheckBig } from "lucide-react";
import { getViewModeChrome } from "../view-mode-chrome";

interface SearchDocsSuccessProps {
  result?: {
    status?: string;
    discovery_summary?: string;
    docs?: string;
    [key: string]: any;
  };
  viewMode?: string;
}

export function SearchDocsSuccess({ result, viewMode}: SearchDocsSuccessProps) {
  const chrome = getViewModeChrome(viewMode);
  const summary = result?.discovery_summary;

  // Extract a short subtitle: first non-empty line of discovery_summary
  const subtitle = summary
    ? summary.split("\n").find((l) => l.trim().length > 0)?.trim().slice(0, 72)
    : "Documentation retrieved";

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="w-full"
    >
      <div className={`rounded-md border ${chrome.card} overflow-hidden`}>
        <div className="px-3 py-2 flex items-center justify-between gap-3 min-w-0">
          <div className="flex items-center gap-2.5 min-w-0">
            <Database className={`w-3.5 h-3.5 ${chrome.iconMuted} shrink-0`} strokeWidth={2} />
            <div className="flex items-center gap-2 min-w-0 flex-1 flex-nowrap">
              <span className={`text-[13px] font-semibold ${chrome.text} truncate`}>
                Intelligence retrieved
              </span>
              {subtitle && (
                <span className={`text-[11px] ${chrome.subtext} truncate max-w-[260px]`}>
                  {subtitle}
                </span>
              )}
            </div>
          </div>

          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1, type: "spring", stiffness: 300 }}
            className="shrink-0"
          >
            <CircleCheckBig className="h-4 w-4 text-green-500" />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}
